// assets/featured-categories-blog-embed.js

class FeaturedCategoriesSlider {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.section = document.getElementById(sectionId);
    
    if (!this.section) return;
    
    this.root = this.section.querySelector('[data-featured-cats-splide]');
    
    if (!this.root || this.root.__mounted) return;
    
    this.root.__mounted = true;
    
    if (!window.Splide) {
      console.warn('Splide library not loaded');
      return;
    }
    
    this.init();
  }

  init() {
    // Initialize Splide carousel
    this.splide = new Splide(this.root, {
      type: 'loop',
      arrows: false,
      pagination: false,
      gap: '20px',
      perPage: 4,
      perMove: 1,
      focus: 'start',
      trimSpace: false,
      breakpoints: {
        1400: { perPage: 4 },
        1200: { perPage: 4 },
        992: { perPage: 3 },
        768: { perPage: 3.1, gap: '14px', clones: 6 },
        540: { perPage: 2.4, gap: '12px', clones: 5 },
        400: { perPage: 2.2, gap: '10px', clones: 5 },
      },
    });

    this.bindArrows();
    this.splide.mount();
  }

  bindArrows() {
    const prev = this.section.querySelector('.cat-prev');
    const next = this.section.querySelector('.cat-next');

    if (prev) {
      prev.addEventListener('click', (e) => {
        e.preventDefault();
        this.splide.go('<');
      });
    }

    if (next) {
      next.addEventListener('click', (e) => {
        e.preventDefault();
        this.splide.go('>');
      });
    }
  }
}

// Initialize all featured category sliders on the page
function initFeaturedCategoriesSliders() {
  const sections = document.querySelectorAll('.featured-categories-new[id]');
  
  sections.forEach(section => {
    const sectionId = section.getAttribute('id');
    new FeaturedCategoriesSlider(sectionId);
  });
}

// Run on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFeaturedCategoriesSliders);
} else {
  initFeaturedCategoriesSliders();
}

// Export for potential external use
window.FeaturedCategoriesSlider = FeaturedCategoriesSlider;
window.initFeaturedCategoriesSliders = initFeaturedCategoriesSliders;